<!-- app-subdomain-creators/src/Components/CreatorChatSearchShowAllImages.vue -->
<template>
  <div>
    <div v-for="(images, month) in groupedImages" :key="month" class="">
      <div class="flex justify-between items-center mb-5">
        <h4 class="text-zinc-500 text-sm font-semibold">{{ month }}</h4>

        <!-- back to menu -->
        <div @click="toggleBackToFiles" class="flex gap-1 cursor-pointer">
          <ArrowLeftIcon class="w-4 text-[#2D8CFF]"></ArrowLeftIcon>
          <div class="text-[#2D8CFF] text-sm font-semibold">
            Back to all Files
          </div>
        </div>
      </div>

    <div class="flex flex-wrap gap-2">
    <div
      v-for="(image, index) in images"
      :key="index"
      class="w-28 h-28 rounded-lg overflow-hidden bg-zinc-100 cursor-pointer"
      @click="handleImageClicked(image)"
    >
      <img
        :src="image.src"
        :alt="image.alt || 'Image'"
        class="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
    </div>

    </div>

    <!-- Load more images (paging) -->
    <div v-if="hasMore" class="mt-4 flex justify-center">
      <button
        type="button"
        class="px-3 py-1.5 text-xs font-medium rounded-full bg-zinc-100 text-zinc-600 hover:bg-zinc-200 disabled:opacity-50"
        :disabled="isLoadingMore"
        @click="onLoadMoreClicked"
      >
        <span v-if="!isLoadingMore">Load older images</span>
        <span v-else>Loading…</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  searchImages: {
    type: Array,
    default: () => [],
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['toggleShowAllImages', 'loadMoreImages', 'open-image']);

const toggleBackToFiles = () => {
  emits('toggleShowAllImages');
};

const onLoadMoreClicked = () => {
  emits('loadMoreImages');
};

const handleImageClicked = (image) => {
  if (!image || !image.src) return;

  emits('open-image', {
    src: image.src,
    name: image.name || image.alt || '',
  });
};

// Grouping images by month, but never dropping them if date is weird/missing
const groupedImages = computed(() => {
  const imagesByMonth = {};
  const list = props.searchImages || [];

  for (const image of list) {
    const rawDate = image.date || image.createdAt || image.timestamp;
    let label = 'Unknown date';

    if (rawDate) {
      const d = new Date(rawDate);
      if (!Number.isNaN(d.getTime())) {
        label = d.toLocaleString('default', {
          month: 'long',
          year: 'numeric',
        });
      }
    }

    if (!imagesByMonth[label]) {
      imagesByMonth[label] = [];
    }
    imagesByMonth[label].push(image);
  }

  return imagesByMonth;
});
</script>

